module.exports = __webpack_public_path__ + "static/service-section-mob-img-ca5a4ad2e613fc595ba4daf07ccf18f4.webp";